import { FC } from 'react';
import { FiArrowRight, FiMapPin } from 'react-icons/fi';
import { useLocationService } from '../../services/location/LocationService';
import { useAdminLocationStore } from '../../services/location/useAdminLocationStore';

import { TsForm } from '@/components/form/Form';
import { SelectInputField } from '@/components/form/SelectInput';
import { PageSizer, SizerMode } from '@/components/page/PageSizer';
import { Button } from '@/components/shared/button/Button';
import { TSTitleCard } from '@/components/shared/card/Card';
import { useAllLocations } from '@/services/useLocations';
import { useForm } from 'react-hook-form';
import strings from './home.translations';

interface AdminLocationForm {
  locationId: string;
}

export const AdminLocationGate: FC = () => {
  const locationList = useAllLocations();
  const setServiceLocation = useLocationService(s => s.setSelectedLocation);
  const setAdminLocation = useAdminLocationStore(s => s.setActingLocation);

  const methods = useForm<AdminLocationForm>({
    defaultValues: { locationId: '' }
  });

  const selectedLocationId = methods.watch('locationId');

  const onSubmit = (data: AdminLocationForm) => {
    const found = locationList.find(l => String(l.id) === data.locationId);
    if (found) {
      setAdminLocation(found);
      setServiceLocation(found);
    }
  };

  return (
    <PageSizer mode={SizerMode.PAGE} className="flex-1 overflow-auto">
      <TSTitleCard
        title={strings.adminGate.selectLocation}
        descriptor={strings.adminGate.selectLocationDescriptor}
        icon={FiMapPin}
      >
        <TsForm methods={methods} onSubmit={onSubmit}>
          <div className="flex flex-col space-y-5">
            <SelectInputField
              id="locationId"
              name="locationId"
              label="Location"
              options={[
                { name: strings.adminGate.selectLocation, value: '' },
                ...locationList.map(location => ({
                  name: location.name,
                  value: String(location.id)
                }))
              ]}
            />

            <div className="flex w-full items-center justify-end">
              <Button
                primary
                type="submit"
                disabled={!selectedLocationId}
                className="flex-1 flex items-center justify-center gap-2"
              >
                {strings.adminGate.continue}
                <FiArrowRight className="w-4 h-4" />
              </Button>
            </div>
          </div>
        </TsForm>
      </TSTitleCard>
    </PageSizer>
  );
};
